
import React from 'react'
import { Modal } from 'react-bootstrap'


const CustomModal = (props) => {
  return (
    <Modal
    {...props}
    size="lg"
    aria-labelledby="contained-modal-title-vcenter"
    centered
    name={`${props?.className}`}
  >
    <Modal.Header closeButton>
    
    </Modal.Header>
    <Modal.Body>
      {props.children}
    </Modal.Body>
    
  </Modal>
  )
}

export default CustomModal